import { rem, rgba } from 'polished';
import styled, { css } from 'styled-components';

import { IBasicUserType } from '../../types';
import { IStyledIconProps } from './IconButton.types';

const ActiveSvg = css`
  path {
    fill: ${({ theme }) => theme.colors.cross.black};
  }

  circle {
    stroke: ${({ theme }) => theme.colors.cross.black};
  }
`;

const InactiveSvg = css`
  path {
    fill: ${({ theme }) => theme.colors.cross.grayson};
  }

  circle {
    stroke: ${({ theme }) => theme.colors.cross.grayson};
  }
`;

export const StyledIcon = styled.span<IStyledIconProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${rem('56px')};
  width: ${rem('56px')};
  padding: ${rem('8px')};
  background-color: ${({ theme }) => theme.colors.main};
  border: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
  border-radius: ${rem('8px')};

  svg {
    display: flex;
    height: auto;
    width: ${({ width }) => (width ? rem(width) : rem('20px'))};
    max-width: ${rem('40px')};
    ${InactiveSvg}
  }
`;

export const StyledLabel = styled.label`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;

export const StyledSpan = styled.span`
  display: flex;
  margin-top: ${rem('8px')};
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('12px')};
  font-weight: 400;
  line-height: 1.17;
  text-align: center;
`;

export const StyledInput = styled.input<IBasicUserType>`
  position: absolute;
  width: 0;
  height: 0;
  appearance: none;
  opacity: 0;

  &:not(:disabled):not(:checked) {
    & + ${StyledLabel}:hover {
      ${StyledIcon} {
        border-color: ${({ theme }) => theme.colors.cross.silverFox};
        box-shadow: 0 0 0
          ${({ theme }) =>
            `${rem('2px')} ${rgba(theme.colors.cross.silverFox, 0.2)}`};

        svg {
          ${ActiveSvg}
        }
      }

      ${StyledSpan} {
        color: ${({ theme }) => theme.colors.cross.black};
      }
    }
  }

  &:not(:disabled):checked {
    & + ${StyledLabel} {
      ${StyledIcon} {
        border-color: ${({ theme, user }) => user && theme.colors[user].main};
        box-shadow: 0 0 0
          ${({ theme, user }) =>
            user &&
            `${rem('2px')} ${rgba(theme.colors[user].mainAlternate, 0.2)}`};

        svg {
          ${ActiveSvg}
        }
      }

      ${StyledSpan} {
        color: ${({ theme }) => theme.colors.cross.black};
      }
    }
  }

  &:disabled {
    & + ${StyledLabel} {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
`;
